<template>
  <div class="vp-receipt">
    <div class="vp-receipt__paper">
      <header class="vp-receipt__header">
        <div class="vp-receipt__header-item">
          <h1 class="vp-receipt__title">{{invoice.belongCompany}}</h1>
          <div class="vp-receipt__meta">{{ '票据号码：NO.' + invoice.realInvoiceCode}}</div>
        </div>
        <div class="vp-receipt__header-item">
          <div class="vp-receipt__subtitle">收款收据（电子）</div>
          <div class="vp-receipt__meta">{{'填制日期：' + invoice.issueDate}}</div>
        </div>
      </header>

      <section class="vp-receipt__section vp-receipt__section--parties">
        <div class="vp-receipt__party">
          <div class="vp-receipt__party-label">付款人</div>
          <div class="vp-receipt__party-rows">
            <div class="vp-receipt__party-row">
              <span class="vp-receipt__field-label">名称：</span>
              <span>{{invoice.invoiceItemName}}</span>
            </div>
            <div class="vp-receipt__party-row">
              <span class="vp-receipt__field-label">统一社会信用代码：</span>
              <span>{{invoice.taxpayerNumber}}</span>
            </div>
          </div>
        </div>
        <div class="vp-receipt__party">
          <div class="vp-receipt__party-label">收款人</div>
          <div class="vp-receipt__party-rows">
            <div class="vp-receipt__party-row">
              <span class="vp-receipt__field-label">名称：</span>
              <span>{{invoice.belongCompany}}</span>
            </div>
            <div class="vp-receipt__party-row">
              <span class="vp-receipt__field-label">统一社会信用代码：</span>
              <span>{{invoice.belongCompanyNum}}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="vp-receipt__section">
        <table class="vp-receipt__table">
          <thead>
            <tr>
              <th>收款内容</th>
              <th>摘要</th>
              <th>金额</th>
              <th>备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="detail in invoice.detailVOS" :key="detail.id">
              <td>{{detail.xmmc}}</td>
              <td></td>
              <td>{{detail.xmdj}}</td>
              <td></td>
            </tr>
            <!-- <tr>
              <td>代办公积金款</td>
              <td>2026年2月公积金费用</td>
              <td>5800.00</td>
              <td>代收代付</td>
            </tr>
            <tr>
              <td>代发工资款</td>
              <td>2026年1月工资</td>
              <td>89000.00</td>
              <td>代收代付</td>
            </tr> -->
          </tbody>
        </table>
      </section>

      <section class="vp-receipt__section vp-receipt__section--amount">
        <div class="vp-receipt__amount-row">
          <span>金额合计（大写）：</span>
          <span>{{invoice.amountA}}</span>
        </div>
        <div class="vp-receipt__amount-row">
          <span>{{'（小写）￥' + invoice.amount}}</span>
        </div>
      </section>
      
      <section class="vp-receipt__section vp-receipt__section--note">
        <p>本凭证中代发工资/社保等款项为代收代付性质，仅作为资金依据。</p>
      </section>
      
      <section class="vp-receipt__section vp-receipt__section--sign">
        <div class="vp-receipt__sign-item">
          <span class="vp-receipt__sign-item_label">收款人：{{invoice.invoiceIncomePer}}</span>
          <span class="vp-receipt__sign-item_value"></span>
        </div>
        <div class="vp-receipt__sign-item">
          <span class="vp-receipt__sign-item_label">复核人：{{invoice.invoiceCheckPer}}</span>
          <span class="vp-receipt__sign-item_value"></span>
        </div>
        <div class="vp-receipt__sign-item">
          <span class="vp-receipt__sign-item_label">收款单位（章）：</span>
          <span class="vp-receipt__sign-item_value"></span>
        </div>
      </section>
    </div>
  
    <section class="vp-main__statement-card">
      <div class="vp-main__statement-head">
        <span class="vp-main__statement-icon vp-main__statement-icon--blue">i</span>
        <span class="vp-main__statement-title">官方声明</span>
      </div>
      <ul class="vp-main__statement-list">
        <li>1、本平台是{{invoice.belongCompany}}唯一授权的电子收据核验渠道,任何其他平台的核验结果均不具备法律效力；</li>
        <li>2、每张电子收据对应唯一核验码(89757-202602-10276143),可通过本平台永久核验,篡改无效；</li>
        <li>3、如需进一步验证收据真实性,可拨打官方客服热线:400-XXXX-XXXX (工作日9:00-18:00)。</li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ReceiptView',

  props: {
       invoice: {
       	type: Object,
       	default: {},
       }
    },
    data() {
      return {
      };
    },
    methods: {

    }

};
</script>

<style lang="scss" scoped>
.vp-receipt {
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  max-width: 1200px;
  margin-top: 20px;

  .vp-receipt__paper {
    width: 100%;
    border: 2px solid #8b4513;
    background: #faf0e6;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 8px;
    color: #8b4513;
  }

  .vp-receipt__header {
    position: relative;
    text-align: center;
    margin-bottom: 20px;
    line-height: 36px;
    .vp-receipt__header-item {
      display: flex;
      .vp-receipt__title {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 4px;
      }
      .vp-receipt__subtitle {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 8px;
      }
      .vp-receipt__title,
      .vp-receipt__subtitle {
        flex: 1;
      }
      .vp-receipt__meta {
        font-size: 12px;
        gap: 4px;
      }
    }
  }

  .vp-receipt__section {
    margin-top: 16px;
  }

  .vp-receipt__section--parties {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 16px;
  }

  .vp-receipt__section--amount {
    display: flex;
    align-items: stretch;
    font-weight: 500;
    border: 1px solid #8b4513;
    padding: 12px 16px;
  }

  .vp-receipt__section--note {
    font-size: 13px;
    text-align: left;
    color: #333;
  }
  
  .vp-receipt__section--amount .vp-receipt__amount-row {
    font-weight: 700;
    font-size: 14px;
    flex: 1;
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }

  .vp-receipt__section--sign {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    flex-direction: row;
    gap: 10px;
  }

  .vp-receipt__section--sign .vp-receipt__sign-item {
    flex: 1;
    border-bottom: 1px solid #8b4513;
    padding: 8px 0;
    .vp-receipt__sign-item_value {
      display: inline-block;
    }
  }

  .vp-receipt__party {
    border: 1px solid #8b4513;
    padding: 0;
    overflow: hidden;
    display: flex;
  }

  .vp-receipt__party-label {
    width: 60px;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    padding: 10px 15px;
    border-right: 1px solid #8b4513;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.2;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .vp-receipt__party-rows {
    flex: 1;
  }
  
  .vp-receipt__party-row {
    display: flex;
    font-size: 14px;
    line-height: 1.6;
    padding: 10px 15px;
    border-bottom: 1px solid #8b4513;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .vp-receipt__party-row:last-child {
    border-bottom: none;
  }

  .vp-receipt__field-label {
    margin-right: 4px;
    white-space: nowrap;
    font-weight: 700;
  }

  .vp-receipt__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    border: 1px solid #8b4513;
  }

  .vp-receipt__table th,
  .vp-receipt__table td {
    border: 1px solid #8b4513;
    padding: 8px 10px;
    width: 25%;
  }

  .vp-receipt__table th {
    font-weight: 700;
    text-align: center;
  }
  
  .vp-receipt__table th:nth-child(1),
  .vp-receipt__table td:nth-child(1) {
    text-align: left;
  }
  
  .vp-receipt__table th:nth-child(3),
  .vp-receipt__table td:nth-child(3) {
    text-align: right;
  }
  
  .vp-receipt__table th:nth-child(2),
  .vp-receipt__table th:nth-child(4),
  .vp-receipt__table td:nth-child(2),
  .vp-receipt__table td:nth-child(4) {
    text-align: center;
  }

  .vp-receipt__amount-row {
    font-size: 13px;
  }

  .vp-receipt__sign-item {
    min-width: 120px;
    font-size: 13px;
  }
  
  .vp-main__statement-card {
    margin-top: 20px;
    width: 100%;
    max-width: 1200px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 24px 28px 20px;
    box-sizing: border-box;
  }
  
  .vp-main__statement-head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .vp-main__statement-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 14px;
    font-weight: 700;
    font-style: italic;
    margin-right: 10px;
    flex-shrink: 0;
  }
  
  .vp-main__statement-icon--blue {
    background: #013f8a;
    color: #ffffff;
  }
  
  .vp-main__statement-title {
    font-size: 18px;
    font-weight: 700;
    color: #013f8a;
  }
  
  .vp-main__statement-list {
    margin: 0 0 10px 0;
    font-size: 14px;
    line-height: 1.7;
    color: #555555;
  }
  
  .vp-main__statement-list li {
    margin-bottom: 3px;
  }
  
  .vp-main__statement-list li:last-child {
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .vp-receipt {
    .vp-receipt__paper {
      padding: 16px 12px;
    }

    .vp-receipt__header {
      padding-top: 8px;
      .vp-receipt__header-item {
        display: flex;
        flex-direction: column;
        .vp-receipt__title {
          /*font-size: 20px;*/
          /*font-weight: 700;*/
          /*color: #8b4513;*/
          /*margin-bottom: 4px;*/
        }
        .vp-receipt__subtitle {
          /*font-size: 16px;*/
          /*font-weight: 700;*/
          /*color: #8b4513;*/
          margin-bottom: 0;
        }
        .vp-receipt__meta {
          text-align: right;
          row-gap: 4px;
        }
      }
    }

    .vp-receipt__section--parties {
      grid-template-columns: minmax(0, 1fr);
      row-gap: 8px;
    }

    .vp-receipt__section--sign {
      flex-direction: column;
      row-gap: 8px;
    }
    
    .vp-receipt__party {
      display: block;
      .vp-receipt__party-label {
        display: block;
        width: 100%;
        padding: 8px 12px;
        border-right: none;
      }
      .vp-receipt__party-rows {
        .vp-receipt__party-row {
          flex-direction: column;
          border-right: none;
          border-top: 1px solid #8b4513;
          border-bottom: none;
        }
      }
    }
  
    .vp-receipt__section--amount {
      flex-direction: column;
      .vp-receipt__amount-row:first-child {
        margin-bottom: 8px;
      }
    }
    
    .vp-main__statement-card {
      padding: 18px 16px 16px;
      margin-top: 16px;
    }
  
    .vp-main__statement-title {
      font-size: 16px;
    }
  
    .vp-main__statement-list {
      font-size: 13px;
    }
  }
}
</style>

